import { useState } from 'react';
import MasterService from '../../services/master';

interface Branch {
    id: number;
    name: string;
}
export const useBranch = () => {
    const [isLoadingBranchList, setIsLoadingBranchList] = useState<boolean>(false);
    
    const getBranchList = async () => {
        try {
        setIsLoadingBranchList(true);
        const response = await MasterService.getAllBranches();

        if (response.data) {
            const branchList = response.data.ramas.map(
            ({ codigoRama, descripcionRama }) => ({
                label: descripcionRama,
                value: codigoRama,
            })
            );
            return branchList;
        }
        } catch (error) {
        } finally {
            setIsLoadingBranchList(false);
        }
    }

    return {
        getBranchList,
        isLoadingBranchList, 
        setIsLoadingBranchList
      };
}
